/**
 * Packlist items carry snapshotted barcodes from picking-service
 * (packlist_items.barcodes → PacklistItem.barcodes). Prefer those over a live
 * catalogue lookup so ops sees the barcode that was current when the item was picked.
 */

export const collectItemIds = (packlistData = []) => {
  const seen = []

  const add = (id) => {
    if (id && !seen.includes(id)) {
      seen.push(id)
    }
  }

  const packlists = packlistData || []
  packlists.forEach((packlist) => {
    const items = packlist?.items || []
    items.forEach((item) => {
      add(item?.itemId)
      add(item?.originalItem?.itemId)
    })
  })

  return seen
}

const primaryBarcode = (barcodes) => (barcodes || []).find(Boolean)

/**
 * Build itemId → primary barcode from packlist payload barcodes.
 */
export const mapBarcodesFromPacklists = (packlistData = []) => {
  const byItemId = {}

  const add = (item) => {
    if (!item?.itemId) {
      return
    }
    const barcode = primaryBarcode(item.barcodes)
    if (barcode) {
      byItemId[String(item.itemId)] = barcode
    }
  }

  (packlistData || []).forEach((packlist) => {
    (packlist?.items || []).forEach((item) => {
      add(item)
      if (item?.originalItem) {
        add(item.originalItem)
      }
    })
  })

  return byItemId
}
